import { render } from "./Stock Location.vue?vue&type=template&id=55ccf7d6"
import script from "./Stock Location.vue?vue&type=script&lang=js"
export * from "./Stock Location.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__